import React, { useEffect, useState } from "react";
import logo from "../assets/logo/logo_header.png";

export default function RebrandModal() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const seen = sessionStorage.getItem("sms_rebrand_modal_shown");
    if (!seen) {
      const t = setTimeout(() => setOpen(true), 600);
      return () => clearTimeout(t);
    }
  }, []);

  const close = () => {
    setOpen(false);
    sessionStorage.setItem("sms_rebrand_modal_shown", "1");
  };

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && close();
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = "";
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-md animate-fadeUp"
      onClick={close}
    >
      <div
        className="relative w-full max-w-lg bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-gold/40"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="absolute top-0 left-0 w-40 h-40 bg-gold/15 rounded-full blur-3xl pointer-events-none" />
        <div className="absolute bottom-0 right-0 w-40 h-40 bg-maroon/15 rounded-full blur-3xl pointer-events-none" />

        <button
          onClick={close}
          className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white border border-gold/40 text-maroon hover:bg-maroon hover:text-white transition-colors flex items-center justify-center shadow"
          aria-label="Close"
        >
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <div className="relative px-6 sm:px-10 py-10 sm:py-12 text-center">
          <div className="flex justify-center mb-5">
            <img
              src={logo}
              alt="SMS Gold"
              className="h-16 sm:h-20 w-auto object-contain drop-shadow-md"
            />
          </div>

          <div className="text-[10px] sm:text-xs uppercase tracking-[0.4em] text-gold-dark font-semibold mb-3">
             Heritage Continues
          </div>

          <div className="font-serif text-xl sm:text-2xl text-maroon font-bold leading-snug mb-1">
            Shivkumar Mangaldas Soni
          </div>
          <div className="text-xs sm:text-sm text-gray-500 mb-5">
            Est. 1933  Visnagar
          </div>

          <div className="flex items-center justify-center gap-3 mb-5">
            <div className="h-px flex-1 max-w-[80px] bg-gradient-to-r from-transparent to-gold" />
            <div className="px-4 py-1 rounded-full bg-maroon text-gold text-[10px] sm:text-xs uppercase tracking-[0.4em] font-bold shadow-md">
              Now
            </div>
            <div className="h-px flex-1 max-w-[80px] bg-gradient-to-l from-transparent to-gold" />
          </div>

          <div className="font-serif text-3xl sm:text-4xl gold-gradient-text font-bold leading-tight mb-3">
            Shivkumar Jewellers
          </div>

          <p className="text-xs sm:text-sm text-gray-600 leading-relaxed mb-6 max-w-sm mx-auto">
            The same heritage, the same trust, refreshed with a new
            identity. Five generations of craft, now under our new name.
          </p>

          <button
            onClick={close}
            className="inline-flex items-center gap-2 bg-maroon text-white px-7 py-3 rounded-full font-semibold text-sm hover:bg-maroon-dark transition-colors shadow-lg"
          >
            Explore the Legacy
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="5" y1="12" x2="19" y2="12" />
              <polyline points="12 5 19 12 12 19" />
            </svg>
          </button>
        </div>

        <div className="h-2 bg-gradient-to-r from-gold via-maroon to-gold" />
      </div>
    </div>
  );
}
